import { useEffect } from "react";
import { useHistoryStore } from "../store";

export default function useUndoRedoShortcuts() {
  useEffect(() => {
    const handleKeyDown = (e) => {
      const isMac = navigator.platform.toUpperCase().includes("MAC");
      const ctrlKey = isMac ? e.metaKey : e.ctrlKey;
      const key = e.key.toLowerCase();

      if (!ctrlKey) return;

      // Ctrl/Cmd + Z -> Undo
      if (key === "z" && !e.shiftKey) {
        useHistoryStore.getState().undo();
        e.preventDefault();
        return;
      }

      // Ctrl/Cmd + Shift + Z or Ctrl + Y -> Redo
      if ((key === "z" && e.shiftKey) || key === "y") {
        useHistoryStore.getState().redo();
        e.preventDefault();
        return;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);
}
